/* file description */

export const ERROR_MSG_MAP = {
  autoLineEditConfigWithOutRequest: `要开启自动化编辑配置能力, 请务必使用request参数, 
  为您写好了该能力的demo，请点击链接前往： `,
  autoLineEditOnSaveRunError: '传入的autoLineEditOnSave函数请求失败了！',
  autoLineEditOnDeleteRunError: '传入的autoLineEditOnDetele函数请求失败了！',
  autoLineEditConfigWithOutOndelete: '需要传入autoLineEditConfig.onDelete以开启此功能！',
  autoAddRecordConfigWithOutOnSave: '需要传入autoAddRecordConfig.onSave函数以开启自动化新增功能!',
};
